import { IGeneric2AutoComplete } from "../../_common/interface/autocomplete/iStandard2Autocomplete";
import { dropdownService } from "../../_services/dropdown.service";
import StandardMultipleAutoComplete from "./standardMultiple.autocomplete";

export const DataTypeMultipleAutoComplete = (params: IGeneric2AutoComplete) => {


    return (
        <StandardMultipleAutoComplete
            {...params}
            itemsLoader={() => dropdownService.fetchFormDataMultiple(params.dataType, params.parentId)}
        />
    );
}